import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { TransactionRevisionReason } from "../_types/transaction-revision-reason";

@Injectable({
    providedIn: 'root',
})
export class TransactionsRevisionsReasonsService extends Service<TransactionRevisionReason> {
    public override type = 'transactionRevisionReasons';
    public override url = 'invoicing/transactionRevisionReasons';
}
